export const usePagination = ({ pageSize, data, currentPage }) => {
  const startRow = (currentPage - 1) * pageSize;
  const endRow = currentPage * pageSize;
  const paginatedData = data.slice(startRow, endRow);
  const numberOfPages = Math.ceil(data.length / pageSize);

  return { numberOfPages, paginatedData };
}